import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { PAGE_SIZE_OPTIONS } from '../../../constants';
import StyledSelect from '../../FormComponents/Select/Select.style';

const PageSizeField = ({ onChange }) => {
  return (
    <Form>
      <Form.Group inline>
        <label htmlFor="results_select">Results per page:</label>
        <StyledSelect className="select">
          <select
            onChange={onChange}
            className="ui selection dropdown"
            id="results_select"
          >
            {PAGE_SIZE_OPTIONS.map(size => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </StyledSelect>
      </Form.Group>
    </Form>
  );
};

PageSizeField.propTypes = {
  onChange: PropTypes.func
};
export default PageSizeField;
